import { convertUnitsToPixels } from 'assets/js/helpers/convert-units-to-pixels';

var ElementSetter = require('./abstract/element');
var ImagesFactory = require('../../../factory/images');

module.exports = TemplateSetter;

function TemplateSetter () {
  this.handledAttributes = [
    'keep_stage_size',
    'resize_content',
    'restricted.id',
    'restricted.page',
    'restricted.keep_permissions',
    'size.format_id',
    'size.width',
    'size.height',
    'size.unit',
    'grid.index_in_set',
    'grid.number_of_photos',
    'designed.id',
    'designed.content'
  ];
}

TemplateSetter.prototype = new ElementSetter();
TemplateSetter.prototype.constructor = TemplateSetter;

TemplateSetter.prototype.set = function (data) {
  var isTemplateSetCommand = data['designed'] &&
    (data['designed']['id'] || data['designed']['content']);

  var isGridSetCommand = data['grid'] &&
    data['grid']['index_in_set'] && data['grid']['number_of_photos'];

  var isRestrictedSetCommand = data['restricted'] && data['restricted']['id'];

  var isSetCommand = isGridSetCommand || isTemplateSetCommand;

  isRestrictedSetCommand && this.setRestrictedTemplate(data);
  isTemplateSetCommand && this.setDesignedTemplate(data);
  isGridSetCommand && this.setGridTemplate(data);
  isSetCommand || (data['size'] && this.updateSize(data));

  this.trigger('', null, data);
};

TemplateSetter.prototype.setRestrictedTemplate = function (data) {
  INKIVE.Helpers.api(
    'page/consume_credits', 'GET', {
      page: data['restricted']['page'] || 1,
      scrapbook_id: data['restricted']['id']
    }, _.bind(onCreditsConsumed, this)
  );

  async function onCreditsConsumed (result, success) {
    if (success && result) {
      let pageId = data['restricted']['page_id'];

      if (!pageId) {
        const pageNumber = data['restricted']['page'] || 1;
        const template = await INKIVE.DesygnerApi.get(`brand/templates/${data['restricted']['id']}`);
        if (!template?.pages[pageNumber - 1]?.id) throw new Error('Page not found');
        pageId = template.pages[pageNumber - 1].id;
      }

      const project = await INKIVE.DesygnerApi.get(`business/projects/${data['restricted']['id']}/pages/${pageId}`);

      onTemplatePage.call(this, project);
    }
  }

  function onTemplatePage (project) {
    // TODO?
    // var newImagesData = INKIVE.ImagesFactory.setImagesData(result.images);
    // _.each(newImagesData, function (imageData) {
    //   imageData.stored = true;
    // });

    this.editor.loadSvgString(project.content, _.bind(function () {
      var editorFacade = require('../../editor/editor');
      var $svgcontent = $('#svgcontent');
      editorFacade.handle('zoom', 'fit');

      data['restricted']['keep_permissions']
        && $svgcontent.children('g.main')
          .addClass('base-page-' + data['restricted']['page']);

      if (_.include([INKIVE.C.BOOK_TYPE.TEMPLATE, INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN], INKIVE.C.BOOK.book_type)) {
        INKIVE.EditorFacade.once('history.reload', _.bind(function () {
          $svgcontent.find('.element.group').each(function () {
            INKIVE.DesignFacade.handle(this.id, 'ungroup');
          });
          this.canvas.clearSelection();
        }, this));
      }

      this.trigger('restricted', null, { 'restricted': data['restricted'] });
    }, this));
  }
};

TemplateSetter.prototype.setDesignedTemplate = function (data) {
  if (data['designed']['content']) {
    onLayoutData.call(
    this, data['designed']['content']
  );
  } else {
    INKIVE.Helpers.api(
    'search/layout', 'GET',
    { id: data['designed']['id'] },
    _.bind(onLayoutData, this)
  );
  }

  function onLayoutData (layoutData) {
    data['format'] = { 'id': layoutData['format_id'] };
    data['designed']['id'] = data['designed']['id']
      || data['designed']['content']['id'];

    if (!data['keep_stage_size']) {
      data['size'] = {
        width: layoutData['format_width'],
        height: layoutData['format_height']
      };
      this.updateSize(data);
    }

    this.onSVGData(data, {
      defs: Base64.decode(layoutData['defs']),
      content: Base64.decode(layoutData['content']),
      background: Base64.decode(layoutData['background'])
    }, layoutData);

    this.trigger('designed', null, { 'designed': data['designed'] });
    INKIVE.C.IS_MOBILE_APP || _.delay(function () {
      INKIVE.DesignFacade.handle('preview');
    }, 1000);
  }
};

TemplateSetter.prototype.setGridTemplate = function (data) {
  const url = INKIVE.C.BASE_URL + 'grid/fetch/' + data.grid.index_in_set;

  const newWidth = !data.size
    ? this.canvas.contentW
    : data.size.unit
      ? convertUnitsToPixels(
        data.size.width,
        data.size.unit,
        false,
        data.size.dpi ?? 72
      )
      : parseInt(data.size.width);

  const newHeight = !data.size
    ? this.canvas.contentHeight
    : data.size.unit
      ? convertUnitsToPixels(
        data.size.height,
        data.size.unit,
        false,
        data.size.dpi ?? 72
      )
      : parseInt(data.size.height);

  const params = {
    width: newWidth,
    height: newHeight,
    number_of_photos: data.grid.number_of_photos
  };

  const callback = (result) => {
    const isSameFormat =
      Number(params.width) === Number(this.canvas.contentW) &&
      Number(params.height) === Number(this.canvas.contentH);

    result = JSON.parse(result);
    isSameFormat || this.updateSize(data);

    result.STATUS === 'SUCCESS' &&
      this.onSVGData(data, {
        defs: result.MESSAGE.defs,
        content: result.MESSAGE.svg
      });

    this.trigger('grid', null, { grid: data.grid });
  };

  INKIVE.Helpers.sendCmd(url, params, callback);
};

TemplateSetter.prototype.updateSize = function (data) {
  var $svg = $('#svgcontent');
  var $element = $svg.children('g.main');
  var editorFacade = require('../../editor/editor');
  var convertToPixels = INKIVE.Helpers.convertUnitsToPixels;
  var resizeContent = typeof data['resize_content'] === 'undefined'
    ? (!data['restricted'] && !data['grid'] && !data['designed'])
    : data['resize_content'];

  var newWidth = data['size']['unit']
    ? convertToPixels(data['size']['width'], data['size']['unit'], false, data['size']['dpi'])
    : parseInt(data['size']['width']);

  var newHeight = data['size']['unit']
    ? convertToPixels(data['size']['height'], data['size']['unit'], false, data['size']['dpi'])
    : parseInt(data['size']['height']);
  var currentSize = data['size']['current_size'];

  if (currentSize){
    newHeight = currentSize['height'];
    newWidth = currentSize['width'];
  }

  var oldWidth = this.canvas.contentW;
  var oldHeight = this.canvas.contentH;

  removeInfoClasses();
  data['size']['unit'] && $svg.addClass('du-' + data['size']['unit']);
  $svg.addClass('dw-' + data['size']['width']);
  $svg.addClass('dh-' + data['size']['height']);

  if (newWidth != oldWidth || newHeight != oldHeight) {
    this.canvas.contentW = newWidth;
    this.canvas.contentH = newHeight;

    editorFacade.handle('zoom', 'fit');
    resizeContent && this._resizeCanvasContent({
      height: oldHeight,
      width: oldWidth
    });
  }

  this.trigger('size', null, {'size': data['size']});

  if (data['size']['format_id']) {
    removeInfoClasses(/format-id-[\d+]/);
    $element.addClass('format-id-' + data['size']['format_id']);
  }

  function removeInfoClasses (exp) {
    var svg = $svg[0];
    var element = $element[0];
    if (!element || !svg) return;
    var list = _.union(_.toArray(element.classList), _.toArray(svg.classList));

    _.each(list, function (className) {
      if (exp) {
        className.match(exp) && element.classList.remove(className);
      } else {
        className.match(/format-id-[\d+]/) && element.classList.remove(className);
        className.match(/layout-id-[\d+]/) && element.classList.remove(className);
        className.match(/du-[\w+]/) && svg.classList.remove(className);
        className.match(/dw-[\d|\.]+/) && svg.classList.remove(className);
        className.match(/dh-[\d|\.]+/) && svg.classList.remove(className);
      }
    });
  }
};

TemplateSetter.prototype.onSVGData = function (data, layoutInfo, layoutData) {
  this.editor.addElement('layout', $.extend({
    keep: data.setCurrentPage
  }, layoutInfo));

  addInfoClasses($('#svgcontent > g.main'));
  cleanNonsenseTextNodes($('#svgcontent')[0]);
  INKIVE.Helpers.converterCurrentPage();

  data['keep_stage_size'] && this._resizeCanvasContent({
    height: layoutData['format_height'],
    width: layoutData['format_width'],
    unit: layoutData['unit']
  });

  function addInfoClasses ($element) {
    data['designed'] && data['designed']['id'] && $element.addClass(
      'layout-id-' + data['designed']['id']
    );

    data['grid'] && data['grid']['index_in_set'] && data['grid']['number_of_photos'] && $element.addClass(
      'grid-id-' + data['grid']['number_of_photos'] + '-' + data['grid']['index_in_set']
    );

    if (!data['keep_stage_size']) {
      data['format'] && data['format']['id'] && $element.addClass(
        'format-id-' + data['format']['id']
      );
    }
  }

  function cleanNonsenseTextNodes (node) {
    node.firstChild && cleanNonsenseTextNodes(node.firstChild);
    node.nextSibling && cleanNonsenseTextNodes(node.nextSibling);

    if (node.nodeType === 3) {
      node.nodeValue.match(/(\r\n|\r|\n)+/g) && node.remove();
    }
  }
};

TemplateSetter.prototype._resizeCanvasContent = function (oldSize) {
  var convertToPixels = INKIVE.Helpers.convertUnitsToPixels;

  INKIVE.Helpers.converterLayoutSizeChange(
    this.canvas.contentW,
    this.canvas.contentH,
    convertToPixels(oldSize['width'], oldSize['unit']),
    convertToPixels(oldSize['height'], oldSize['unit'])
  );
};
